import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_uzucr6decz: FaireBrandEntity = {
  token: "b_uzucr6decz",
  type: "brand",
  name: "MicroPower Industrial Inc",
  avatarUrl:
    "https://cdn.faire.com/fastly/f27ca536b8eb0fc21658184b5bf7f413de59328f5744395ee2641094ea5b54e2.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d22e4d8b059d21c0c9ae8fff55d6ed36c46d801a90b5a5377742f3d2c8df419f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/f27ca536b8eb0fc21658184b5bf7f413de59328f5744395ee2641094ea5b54e2.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d22e4d8b059d21c0c9ae8fff55d6ed36c46d801a90b5a5377742f3d2c8df419f.png",
  location: "Montclair, CA, USA",
  minimumOrderDollars: 80,
  rating: 5,
  reviewCount: 1,
  isInsider: true,
  description: "About Pandaoo\n\nWe funded at 2015",
  meta: {
    source: "api",
    importedAt: "2026-07-17T21:32:12.910Z",
    importedBy: "entity-db-cli",
  },
};
